// extracted by mini-css-extract-plugin
export default {"comingSoonContainer":"ComingSoon_comingSoonContainer__yuOZ7","comingSoonContent":"ComingSoon_comingSoonContent__n8KSW"};